import React from 'react';

const DollarSquare = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <g clipPath="url(#clip0_4418_169697)">
        <path
          d="M13.3999 17.4201H10.8899C9.24991 17.4201 7.91991 16.0401 7.91991 14.3401C7.91991 13.9301 8.25991 13.5901 8.66991 13.5901C9.07991 13.5901 9.41991 13.9301 9.41991 14.3401C9.41991 15.2101 10.0799 15.9201 10.8899 15.9201H13.3999C14.0499 15.9201 14.5899 15.3401 14.5899 14.6401C14.5899 13.7701 14.2799 13.6001 13.7699 13.4201L9.73991 12.0001C8.95991 11.7301 7.90991 11.1501 7.90991 9.36008C7.90991 7.82008 9.11991 6.58008 10.5999 6.58008H13.1099C14.7499 6.58008 16.0799 7.96008 16.0799 9.66008C16.0799 10.0701 15.7399 10.4101 15.3299 10.4101C14.9199 10.4101 14.5799 10.0701 14.5799 9.66008C14.5799 8.79008 13.9199 8.08008 13.1099 8.08008H10.5999C9.94991 8.08008 9.40991 8.66008 9.40991 9.36008C9.40991 10.2301 9.71991 10.4001 10.2299 10.5801L14.2599 12.0001C15.0399 12.2701 16.0899 12.8501 16.0899 14.6401C16.0799 16.1701 14.8799 17.4201 13.3999 17.4201Z"
          fill="currentColor"
          style={{ fill: 'var(--fillg)' }}
        />
        <path
          d="M12 18.75C11.59 18.75 11.25 18.41 11.25 18V6C11.25 5.59 11.59 5.25 12 5.25C12.41 5.25 12.75 5.59 12.75 6V18C12.75 18.41 12.41 18.75 12 18.75Z"
          fill="currentColor"
          style={{ fill: 'var(--fillg)' }}
        />
        <path
          d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
          fill="currentColor"
          style={{ fill: 'var(--fillg)' }}
        />
      </g>
      <defs>
        <clipPath id="clip0_4418_169697">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DollarSquare;
